import React from 'react';
import { GridApi } from 'ag-grid-community';
import './styles.scss';
import { useIntl } from 'react-intl';

export interface StatusBarProps {
    gridApi: GridApi | undefined;
}

function StatusBar(props: StatusBarProps) {
    const { gridApi } = props;

    const { formatMessage } = useIntl();

    return (
        <div className="status-bar">
            <div className="status-bar-item">
                <span>{`${formatMessage({ id: 'commonSelected' })}: `}</span>
                <strong>{`${gridApi ? gridApi.getSelectedRows().length : 0}`}</strong>
            </div>
        </div>
    );
}

export default StatusBar;
